<template>
  <div class="portal-reviews-filter__input-group">
    <input
      class="portal-reviews-filter__input"
      type="text"
      :value="value"
      v-on:input="$emit('input', $event.target.value)"
    />
    <button
      class="
        portal-reviews-filter__close-button portal-reviews-filter__arrow-button
      "
      v-on:click="$emit('close')"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'search-input',

  props: {
    value: String,
  },

  // Emits:
  // input: String
  // close: null
};
</script>

<style lang="scss">
.portal-reviews-filter__input-group {
  display: flex;
}

.portal-reviews-filter__input {
  width: 151px;
  box-sizing: border-box;
  height: 32px;
  background: var(--black-l95);
  outline: none;
  padding: 8px 10px;
  border: 1px solid;
  border-color: var(--black-l65) transparent transparent var(--black-l65);
}

.portal-reviews-filter__close-button {
  width: 29px;
  height: 32px;
  background: var(--black-l95);
  outline: none;
  transform: rotate(180deg);
  border: 1px solid;
  border-color: transparent transparent var(--black-l65) var(--black-l65);
}
</style>
